// src/components/mathJaxConfig.js
const mathJaxConfig = {
  loader: {
    load: ['[tex]/html', '[tex]/mhchem', '[tex]/physics']
  },
  tex: {
    packages: { '[+]': ['html', 'mhchem', 'physics'] },
    inlineMath: [['$', '$']],
    displayMath: [['$$', '$$']],
    processEnvironments: true,
    processEscapes: true,
    tags: 'ams'
  },
  options: {
    skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
    enableMenu: false
  },
  startup: {
    pageReady: () => {
      return Promise.resolve();
    }
  }
};

export default mathJaxConfig;